function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;


// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/@babel/runtime/helpers/arrayLikeToArray.js